'use client';
import { memo, useState } from 'react';
import { getCorpType, getCDNImageUrl, calculateSize } from '../utils/index.mjs';
import DefaultImageMap from './DefaultImage.mjs';
import { jsx } from 'react/jsx-runtime';

const TextImage = _ref => {
  let {
    biInfo,
    height: propHeight,
    width: propWidth,
    type,
    lazyLoading
  } = _ref;
  const [shouldRenderDefault, setShouldRenderDefault] = useState(false);
  if (!biInfo) {
    return DefaultImageMap[getCorpType()]();
  }
  const {
    key,
    scheme
  } = biInfo;

  /** text 타입은 textSize가 scheme에 존재해야한다. */
  if (!('textSize' in scheme && scheme.textSize)) {
    return DefaultImageMap[getCorpType(key)]();
  }
  const [defaultWidth, defaultHeight] = scheme.textSize;
  const {
    height,
    width
  } = calculateSize({
    defaultHeight,
    defaultWidth,
    propHeight,
    propWidth
  });
  const name = `${biInfo.key}_${type}`;
  if (shouldRenderDefault) {
    return DefaultImageMap[getCorpType(key)](height, width);
  }
  return /*#__PURE__*/jsx("img", {
    src: getCDNImageUrl(name),
    alt: name,
    width: width,
    height: height,
    loading: lazyLoading ? 'lazy' : 'eager',
    onError: () => setShouldRenderDefault(true)
  });
};
var TextImage$1 = /*#__PURE__*/memo(TextImage);

export { TextImage$1 as default };
